import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom'
import { selectAccountData, getAccountDetails } from '../redux/main/accountSlice'
import { selectUser } from '../redux/main/authSlice'
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import moment from 'moment';
import { Button, Form, FormGroup, Input, Label, Card, CardHeader, CardBody, CardText, CardFooter } from 'reactstrap';
import Select from 'react-select';
import { useColorPalette } from '../hooks/useColorPalette';
import { selectRightModalIsOpen, selectRightModalmode, selectRightModalId, setModal } from '../redux/rightModalSlice';
import RightModal from '../components/templates/RightModal';
import { getApiBaseUrl, getNodeApiUrl } from '../config/api.config';
import CustomerSelect from '../components/CustomerSelect'
import AssistanceRequestCard from '../components/AssistanceRequestCard'
import MySelect from '../components/MySelect'
import SchedulingOffcanvas from '../components/calendar/SchedulingOffcanvas'

function AssistanceRequests() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const colors = useColorPalette(); // Hook per i colori del tema
    const user = useSelector(selectUser); // Utente autenticato
    const accountData = useSelector(selectAccountData); // Dati dell'account
    
    // Stati per i filtri
    const [meseSelezionato, setMeseSelezionato] = useState('');
    const [annoSelezionato, setAnnoSelezionato] = useState(new Date().getFullYear().toString());
    const [statoSelezionato, setStatoSelezionato] = useState('');
    const [defaultStatusId, setDefaultStatusId] = useState('');
    const [selectedCustomer, setSelectedCustomer] = useState(null);
    const [assistanceRequests, setAssistanceRequests] = useState([]);
    const [filteredRequests, setFilteredRequests] = useState([]);
    const [statiRichiesta, setStatiRichiesta] = useState([]);
    const [assistanceTypes, setAssistanceTypes] = useState([]);
    const [dataLoaded, setDataLoaded] = useState(false); // Flag per indicare se i dati sono stati caricati
    

    
    // Stati per la modale
    const [selectedRequest, setSelectedRequest] = useState(null);
    // Stati per la modale di cambio stato
    const [showStatusModal, setShowStatusModal] = useState(false);
    const [statusToUpdate, setStatusToUpdate] = useState(null);
    const [requestToUpdateStatus, setRequestToUpdateStatus] = useState(null);
    const [isUpdatingStatus, setIsUpdatingStatus] = useState(false);
    
    // Stato per la modale di conferma eliminazione
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [requestToDelete, setRequestToDelete] = useState(null);
    const [isDeleting, setIsDeleting] = useState(false);
    const [linkedJobInfo, setLinkedJobInfo] = useState(null); // Info sulla commessa collegata
    const [isCheckingLinkedJob, setIsCheckingLinkedJob] = useState(false);
    
    // Stati per SchedulingOffcanvas a livello di pagina
    const [showSchedulingOffcanvas, setShowSchedulingOffcanvas] = useState(false);
    const [schedulingPreselectedJob, setSchedulingPreselectedJob] = useState(null);
    
    const rightModalIsOpen = useSelector(selectRightModalIsOpen);
    const rightModalMode = useSelector(selectRightModalmode);
    const rightModalId = useSelector(selectRightModalId);

    // Array dei mesi in italiano
    const mesi = [
        { value: '0', label: 'Gennaio' },
        { value: '1', label: 'Febbraio' },
        { value: '2', label: 'Marzo' },
        { value: '3', label: 'Aprile' },
        { value: '4', label: 'Maggio' },
        { value: '5', label: 'Giugno' },
        { value: '6', label: 'Luglio' },
        { value: '7', label: 'Agosto' },
        { value: '8', label: 'Settembre' },
        { value: '9', label: 'Ottobre' },
        { value: '10', label: 'Novembre' },
        { value: '11', label: 'Dicembre' }
    ];

    // Generazione degli anni dal 2022 all'anno successivo a quello attuale
    const annoCorrente = new Date().getFullYear();
    const anni = [];
    for (let anno = 2022; anno <= annoCorrente + 1; anno++) {
        anni.push({ value: anno.toString(), label: anno.toString() });
    }

    // Gestione del cambio del mese
    const handleMeseChange = (e) => {
        console.log('Cambiato mese:', e.target.value);
        setMeseSelezionato(e.target.value);
        // Il fetchAssistanceRequests verrà richiamato tramite l'useEffect quando lo stato cambia
    };

    // Gestione del cambio dell'anno
    const handleAnnoChange = (e) => {
        console.log('Cambiato anno:', e.target.value);
        setAnnoSelezionato(e.target.value);
        // Il fetchAssistanceRequests verrà richiamato tramite l'useEffect quando lo stato cambia
    };

    // Gestione del cambio dello stato
    const handleStatoChange = (e) => {
        setStatoSelezionato(e.target.value);
    };
    
    // Gestione della selezione del cliente
    const handleCustomerChange = (selectedOption) => {
        setSelectedCustomer(selectedOption);
    };

    // Effetto per caricare i dati dell'account se non sono già stati caricati
    useEffect(() => {
        if (user && user.accountId && (!accountData || !accountData.settings)) {
            dispatch(getAccountDetails({
                accountId: user.accountId,
                token: localStorage.getItem('installamelo-auth-token')
            }));
        }
    }, [dispatch, user, accountData]);

    // Effetto per ottenere gli stati della richiesta di assistenza
    useEffect(() => {
        if (accountData && accountData.settings && accountData.settings.assistanceRequestStatus) {
            setStatiRichiesta(accountData.settings.assistanceRequestStatus);
            console.log('Stati richiesta di assistenza:', accountData.settings.assistanceRequestStatus);
            
            // Trova lo stato con default = true per le nuove richieste
            const statoDefault = accountData.settings.assistanceRequestStatus.find(stato => stato.default === true);
            if (statoDefault) {
                setDefaultStatusId(statoDefault._id);
                // Imposta sempre lo stato predefinito
                console.log('Imposto stato predefinito:', statoDefault._id);
                setStatoSelezionato(statoDefault._id);
            } else {
                // Se non troviamo uno stato predefinito, imposta il primo stato disponibile
                if (accountData.settings.assistanceRequestStatus.length > 0) {
                    const firstStatus = accountData.settings.assistanceRequestStatus[0];
                    setDefaultStatusId(firstStatus._id);
                    // Imposta sempre il primo stato disponibile
                    console.log('Imposto il primo stato disponibile:', firstStatus._id);
                    setStatoSelezionato(firstStatus._id);
                }
            }
        }
    }, [accountData, user]);

    // Funzione per inizializzare i filtri con i valori di default
    const initializeDefaultFilters = () => {
        console.log('Inizializzazione filtri con valori di default');
        // Imposta sempre l'anno corrente
        setAnnoSelezionato(new Date().getFullYear().toString());
        // Resetta gli altri filtri ai valori di default
        setMeseSelezionato('');
        setSelectedCustomer(null);
        // Lo stato verrà impostato nell'useEffect dedicato quando gli stati sono caricati
    };
    
    // Funzione per salvare i filtri correnti in sessionStorage
    const saveFiltersToSessionStorage = () => {
        const filtersToSave = {
            meseSelezionato,
            annoSelezionato,
            statoSelezionato,
            selectedCustomer
        };
        sessionStorage.setItem('assistanceRequestsNoAIFilters', JSON.stringify(filtersToSave));
        console.log('Filtri salvati in sessionStorage:', filtersToSave);
    };
    
    // Effetto per inizializzare i filtri con valori di default all'avvio del componente
    useEffect(() => {
        initializeDefaultFilters();
    }, []);

    // Funzione per caricare i tipi di assistenza
    const fetchAssistanceTypes = async () => {
        try {
            // Recupera il token di autenticazione
            const token = localStorage.getItem('installamelo-auth-token');
            if (!token || !user || !user.accountId) return;
            
            // Costruisci l'URL per ottenere i tipi di assistenza
            const url = `${import.meta.env.VITE_API_BASE_URL}/assistances?accountId=${user.accountId}`;
            
            const response = await fetch(url, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'auth-token': token
                }
            });

            if (!response.ok) {
                throw new Error('Errore nel caricamento dei tipi di assistenza');
            }

            const result = await response.json();
            console.log('Tipi di assistenza caricati:', result);
            setAssistanceTypes(result || []);
        } catch (error) {
            console.error('Errore nel caricamento dei tipi di assistenza:', error);
        }
    };

    // Funzione per determinare il colore della card in base allo stato e alla scadenza
    const getCardBackgroundColor = (request) => {
        // Ottiene l'ID dello stato "creata"
        const getCreatedStatusId = () => {
            if (!accountData || !accountData.settings || !accountData.settings.assistanceRequestStatus) {
                return null;
            }
            
            const createdStatus = accountData.settings.assistanceRequestStatus.find(
                status => status.code === 'creata' || status.code === 'CREATA' || status.label.toLowerCase() === 'creata'
            );
            
            return createdStatus ? createdStatus._id : null;
        };
        
        const createdStatusId = getCreatedStatusId();
        
        // Se la data di scadenza è passata E lo stato è "creata", usa il grigio
        if (request.expirationDate && 
            moment(request.expirationDate).isBefore(moment(), 'day') && 
            createdStatusId && 
            request.statusId === createdStatusId) {
            return '#c2c2c2'; // Grigio per richieste scadute con stato "creata"
        }
        
        // Altrimenti usa il colore dello stato con trasparenza al 50%
        const statusColor = getStatusColor(request);
        
        // Converte il colore esadecimale in RGB con opacità
        const hexToRgba = (hex, alpha = 1) => {
            // Se il colore è già in formato RGB/RGBA, restituiscilo con l'opacità modificata
            if (hex.startsWith('rgb')) {
                const rgbValues = hex.match(/\d+/g);
                if (rgbValues && rgbValues.length >= 3) {
                    return `rgba(${rgbValues[0]}, ${rgbValues[1]}, ${rgbValues[2]}, ${alpha})`;
                }
            }
            
            // Altrimenti converte da hex a rgba
            const r = parseInt(hex.slice(1, 3), 16);
            const g = parseInt(hex.slice(3, 5), 16);
            const b = parseInt(hex.slice(5, 7), 16);
            return `rgba(${r}, ${g}, ${b}, ${alpha})`;
        };
        
        return hexToRgba(statusColor, 0.5); // Colore dello stato con opacità 50%
    };
    
    // Funzione per ottenere il colore dello stato dell'assistenza
    const getStatusColor = (request) => {
        if (!request || !request.statusId || !accountData || !accountData.settings || !accountData.settings.assistanceRequestStatus) {
            return colors.primary || '#3a5a40'; // Colore di default
        }
        
        const stato = accountData.settings.assistanceRequestStatus.find(s => s._id === request.statusId);
        if (stato && stato.color) {
            return stato.color; // Ritorna il colore associato allo stato usando la proprietà color
        }
        
        return colors.primary || '#3a5a40'; // Colore di default se non trovato
    };
    
    // Funzione per ottenere il colore del tipo di assistenza
    const getAssistanceTypeColor = (request) => {
        if (request.assistanceTypeId && assistanceTypes.length > 0) {
            const assistanceType = assistanceTypes.find(type => type._id === request.assistanceTypeId);
            if (assistanceType && assistanceType.color) {
                return assistanceType.color;
            }
        }
        return colors.primary || '#3a5a40';
    };
    
    // Funzione per determinare il colore del testo in base al colore di sfondo
    const getTextColor = (backgroundColor, request) => {
        // Per richieste scadute
        if (request && request.expirationDate && moment(request.expirationDate).isBefore(moment(), 'day')) {
            return colors.textOnHighlight || '#000';
        }
        return colors.textOnBackground || '#000'; // Default: colore testo del tema
    };
    
    // Funzione per ottenere il colore dell'icona in base al tipo
    const getIconColor = (iconType) => {
        switch (iconType) {
            case 'success':
                return colors.iconSuccess || '#4f772d';
            case 'error':
                return colors.iconError || '#bc4749';
            case 'warning':
                return colors.iconWarning || '#ffbf3d';
            case 'primary':
                return colors.iconPrimary || '#3a5a40';
            default:
                return colors.iconDefault || '#6b705c';
        }
    };
    
    // Caricamento delle richieste dal server
    const fetchAssistanceRequests = async () => {
        // Ogni volta che questa funzione viene chiamata, facciamo una richiesta al server
        // per ottenere dati freschi con i filtri attuali
        console.log('Caricamento dati freschi dal server con filtri correnti...');
        console.log('Filtri attuali:', { meseSelezionato, annoSelezionato, statoSelezionato, selectedCustomer });
        
        try {
            // Recupera il token di autenticazione
            const token = localStorage.getItem('installamelo-auth-token');
            if (!token || !user || !user.accountId) {
                console.error('Token o user non disponibili');
                return;
            }

            // Costruisci l'URL con i parametri necessari
            let url = `${import.meta.env.VITE_API_BASE_URL}/assistanceRequests/list?accountId=${user.accountId}`;
            
            // Aggiungi i filtri alla query
            if (annoSelezionato) {
                url += `&year=${annoSelezionato}`;
            }
            
            if (meseSelezionato) {
                url += `&mese=${meseSelezionato}`;
            }
            
            if (statoSelezionato) {
                url += `&statusId=${statoSelezionato}`;
            }
            
            // Aggiungi il cliente selezionato se presente
            if (selectedCustomer && selectedCustomer.value) {
                url += `&customerId=${selectedCustomer.value}`;
            }
            
            console.log('URL richiesta completa:', url);
            
            const response = await fetch(url, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'auth-token': token
                }
            });

            if (!response.ok) {
                throw new Error('Errore nel caricamento delle richieste di assistenza');
            }

            const result = await response.json();
            console.log('Richieste di assistenza caricate:', result);
            
            // L'API può restituire diversi formati, gestiscili entrambi
            let requests = [];
            if (Array.isArray(result)) {
                // Se il risultato è già un array
                requests = result;
                console.log(`Richieste trovate: ${requests.length}`);
            } else if (result.data && Array.isArray(result.data)) {
                // Se il risultato ha una struttura {recordsTotal: N, recordsFiltered: N, data: Array(N)}
                requests = result.data;
                console.log(`Richieste trovate: ${result.recordsTotal}, filtrate: ${result.recordsFiltered}`);
            } else {
                console.error('Formato di risposta non riconosciuto:', result);
                toast.error('Errore nel formato della risposta API');
                return;
            }
            
            // Log dettagliato per debug
            console.log('Array di richieste elaborato:', requests);
            if (requests.length > 0) {
                console.log('Primo elemento dell\'array:', JSON.stringify(requests[0], null, 2));
                
                // Salviamo tutti i dati e li mostriamo direttamente
                console.log('Salvataggio dati ricevuti:', requests.length, 'richieste');
                setAssistanceRequests(requests);
                setFilteredRequests(requests); // Mostro direttamente i risultati filtrati dal server
                setDataLoaded(true);
            } else {
                console.warn('Nessuna richiesta trovata con i filtri attuali');
                toast.info('Nessuna richiesta di assistenza trovata con i filtri attuali');
                setAssistanceRequests([]);
                setFilteredRequests([]);
            }
        } catch (error) {
            console.error('Errore nel caricamento delle richieste:', error);
        }
    };

    useEffect(() => {
        if (user && user.accountId) {
            fetchAssistanceTypes();
        }
    }, [user]);
    
    // Carica nuove richieste dal server ogni volta che cambiano i filtri o il cliente selezionato o l'utente
    useEffect(() => {
        // Carica dati freschi quando cambiano i filtri
        if (user && user.accountId && statiRichiesta.length > 0) {
            
            // Carica i dati freschi dal server con i nuovi filtri
            console.log('Filtri, cliente o utente cambiati, richiesta dati freschi dal server');
            fetchAssistanceRequests();
        }
    }, [meseSelezionato, annoSelezionato, statoSelezionato, selectedCustomer, user, statiRichiesta]);
    
    // Debug solo per visualizzare un elemento di esempio
    useEffect(() => {
        if (assistanceRequests.length > 0) {
            console.log('Esempio di richiesta per debug:', assistanceRequests[0]);
        }
    }, [assistanceRequests]);

    // Funzione per gestire il click su una richiesta
    const handleRequestClick = (request) => {
        // Assicuriamoci che request sia un oggetto valido prima di procedere
        if (request && typeof request === 'object') {
            console.log('Richiesta selezionata:', request);
            // Impostiamo i dati della richiesta nello stato prima di aprire la modale
            setSelectedRequest(request);
            // Quindi apriamo la modale
            dispatch(setModal({
                id: request._id || 'temp-id', // Assicuriamoci di avere sempre un ID
                mode: 'viewAssistanceRequest',
                percentuageWidth: 80
            }));
        } else {
            console.error('Tentativo di aprire dettagli per una richiesta non valida:', request);
        }
    };

    // Funzione per gestire la modifica di una richiesta
    const handleEditRequest = (request) => {
        // Salva i filtri correnti prima di navigare alla pagina di modifica
        saveFiltersToSessionStorage();
        
        // Redirigi al wizard No-AI con i dati precompilati per la modifica
        navigate(`/assistanceRequestsNoAI/edit/${request._id}`, {
            state: { 
                requestData: request,
                isEditMode: true
            }
        });
    };
    
    // Gestione dell'apertura della modale di conferma eliminazione
    const handleDeleteRequest = async (request) => {
        setRequestToDelete(request);
        setLinkedJobInfo(null);
        setIsCheckingLinkedJob(true);
        setShowDeleteModal(true);
        
        // Verifica se c'è una commessa collegata
        try {
            const token = localStorage.getItem('installamelo-auth-token');
            const response = await fetch(getNodeApiUrl(`/assistanceRequests/checkLinkedJob/${request._id}`), {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'auth-token': token
                }
            });
            
            if (response.ok) {
                const data = await response.json();
                if (data.hasLinkedJob) {
                    setLinkedJobInfo({
                        jobId: data.jobId,
                        jobCode: data.jobCode,
                        jobLabel: data.jobLabel
                    });
                }
            }
        } catch (error) {
            console.error('Errore nel verificare commessa collegata:', error);
        } finally {
            setIsCheckingLinkedJob(false);
        }
    };
    
    // Gestione della chiusura della modale di eliminazione
    const handleCloseDeleteModal = () => {
        setShowDeleteModal(false);
        setRequestToDelete(null);
        setLinkedJobInfo(null);
    };
    
    // Funzione per eliminare effettivamente la richiesta
    const handleConfirmDelete = async () => {
        if (!requestToDelete || !requestToDelete._id) return;
        
        setIsDeleting(true);
        try {
            const token = localStorage.getItem('installamelo-auth-token');
            const response = await fetch(getNodeApiUrl('/assistanceRequests'), {
                method: 'DELETE',
                headers: {
                    'Content-Type': 'application/json',
                    'auth-token': token
                },
                body: JSON.stringify({
                    assistanceRequestId: requestToDelete._id
                })
            });
            
            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.message || 'Errore durante l\'eliminazione');
            }
            
            // Ottieni info sulla commessa eliminata dalla risposta
            const responseData = await response.json();
            
            // Aggiorna la lista delle richieste rimuovendo quella eliminata
            setAssistanceRequests(prev => prev.filter(req => req._id !== requestToDelete._id));
            setFilteredRequests(prev => prev.filter(req => req._id !== requestToDelete._id));
            
            // Chiudi la modale
            setShowDeleteModal(false);
            setRequestToDelete(null);
            setLinkedJobInfo(null);
            
            // Mostra messaggio di successo
            if (responseData.data?.deletedLinkedJob) {
                toast.success(`Richiesta di assistenza e commessa ${responseData.data.deletedLinkedJob.code} eliminate con successo`);
            } else {
                toast.success('Richiesta di assistenza eliminata con successo');
            }
        } catch (error) {
            console.error('Errore nell\'eliminazione della richiesta:', error);
            toast.error(`Errore: ${error.message || 'Impossibile eliminare la richiesta'}`);
        } finally {
            setIsDeleting(false);
        }
    };

    // Componente per visualizzare i dettagli della richiesta nella modale
    const AssistanceRequestDetails = ({ request }) => {
        return (
            <div className="assistance-request-details" style={{ padding: '24px' }}>
                {/* Header con info principali, stato e badge */}
                <div className="request-header" style={{
                    borderBottom: '1px solid #e2e8f0',
                    marginBottom: '32px',
                    paddingBottom: '24px',
                    position: 'relative'
                }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                            <div style={{ 
                                width: '48px', 
                                height: '48px', 
                                borderRadius: '50%', 
                                backgroundColor: '#3498db',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                color: 'white',
                                fontSize: '20px'
                            }}>
                                <i className="fa-solid fa-toolbox"></i>
                            </div>
                            <div>
                                <h2 style={{ margin: '0', fontSize: '1.5rem' }}>{request.code || 'Richiesta Assistenza'}</h2>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginTop: '4px' }}>
                                    <span style={{
                                        padding: '4px 10px',
                                        borderRadius: '20px',
                                        backgroundColor: '#edf2f7',
                                        fontSize: '0.8rem',
                                        color: '#4a5568',
                                        fontWeight: 'bold'
                                    }}>
                                        {request.statusLabel || 'Stato N/D'}
                                    </span>
                                    
                                    {request.teleassistenza === true && (
                                        <span style={{
                                            padding: '4px 12px',
                                            borderRadius: '20px',
                                            backgroundColor: '#4299e1',
                                            color: 'white',
                                            fontSize: '0.8rem',
                                            fontWeight: 'bold',
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '6px'
                                        }}>
                                            <i className="fa-solid fa-video"></i>
                                            Teleassistenza
                                        </span>
                                    )}
                                    
                                    {request.expirationDate && (
                                        <span style={{
                                            padding: '4px 10px',
                                            borderRadius: '20px',
                                            backgroundColor: moment(request.expirationDate).isBefore(moment(), 'day') ? '#fed7d7' : '#c6f6d5',
                                            color: moment(request.expirationDate).isBefore(moment(), 'day') ? '#e53e3e' : '#38a169',
                                            fontSize: '0.8rem',
                                            fontWeight: 'bold',
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '6px'
                                        }}>
                                            <i className={`fa-solid ${moment(request.expirationDate).isBefore(moment(), 'day') ? 'fa-clock' : 'fa-calendar-check'}`}></i>
                                            {moment(request.expirationDate).isBefore(moment(), 'day') 
                                                ? `Scaduta: ${moment(request.expirationDate).format('DD/MM/YYYY')}` 
                                                : `Scade: ${moment(request.expirationDate).format('DD/MM/YYYY')}`}
                                        </span>
                                    )}
                                </div>
                            </div>
                        </div>
                        
                        <div style={{ display: 'flex', gap: '8px' }}>
                            <button 
                                onClick={(e) => {
                                    e.stopPropagation();
                                    handleStatusChange(request);
                                }}
                                style={{
                                    padding: '8px 16px',
                                    border: 'none',
                                    borderRadius: '8px',
                                    backgroundColor: '#edf2f7',
                                    color: '#4a5568',
                                    cursor: 'pointer',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '6px',
                                    fontWeight: 'bold',
                                    transition: 'all 0.2s'
                                }}
                                onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#e2e8f0'}
                                onMouseOut={(e) => e.currentTarget.style.backgroundColor = '#edf2f7'}
                            >
                                <i className="fa-solid fa-edit"></i>
                                <span>Cambia Stato</span>
                            </button>
                            
                            <button 
                                onClick={() => handleEditRequest(request)}
                                className="primary"
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '6px',
                                    fontWeight: 'bold',
                                    transition: 'all 0.2s'
                                }}
                            >
                                <i className="fa-solid fa-pen"></i>
                                <span>Modifica</span>
                            </button>
                        </div>
                    </div>
                </div>
                
                {/* Cliente e indirizzo in una card */}
                <div className="card" style={{
                    border: '1px solid #e2e8f0',
                    borderRadius: '12px',
                    padding: '16px',
                    marginBottom: '24px',
                    boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
                    backgroundColor: 'white'
                }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '16px' }}>
                        <div style={{
                            width: '36px',
                            height: '36px',
                            borderRadius: '50%',
                            backgroundColor: '#38b2ac',
                            color: 'white',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center'
                        }}>
                            <i className="fa-solid fa-user"></i>
                        </div>
                        <div>
                            <h3 style={{ margin: '0', fontSize: '1.2rem' }}>Cliente</h3>
                            <p style={{ margin: '4px 0 0 0', color: '#4a5568' }}>{request.customerLabel || 'Cliente N/D'}</p>
                        </div>
                    </div>
                    
                    {request.systemAddressLabel && (
                        <div style={{ display: 'flex', alignItems: 'flex-start', gap: '12px' }}>
                            <div style={{
                                width: '36px',
                                height: '36px',
                                borderRadius: '50%',
                                backgroundColor: '#ed8936',
                                color: 'white',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center'
                            }}>
                                <i className="fa-solid fa-location-dot"></i>
                            </div>
                            <div>
                                <h3 style={{ margin: '0', fontSize: '1.2rem' }}>Indirizzo</h3>
                                <p style={{ margin: '4px 0 0 0', color: '#4a5568' }}>{request.systemAddressLabel}</p>
                            </div>
                        </div>
                    )}
                </div>
                
                {/* Grid di cards con le informazioni principali */}
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))', gap: '24px', marginBottom: '32px' }}>
                    {/* Card Sistema */}
                    <div className="info-card" style={{
                        border: '1px solid #e2e8f0',
                        borderRadius: '12px',
                        padding: '16px',
                        boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
                        backgroundColor: 'white'
                    }}>
                        <h3 style={{ margin: '0 0 16px 0', display: 'flex', alignItems: 'center', gap: '8px' }}>
                            <i className="fa-solid fa-plug" style={{ color: '#4299e1' }}></i>
                            Informazioni Sistema
                        </h3>
                        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' }}>
                            <div>
                                <div style={{ fontSize: '0.9rem', color: '#718096' }}>Sistema</div>
                                <div style={{ fontWeight: 'bold' }}>{request.systemLabel || 'N/D'}</div>
                            </div>
                            <div>
                                <div style={{ fontSize: '0.9rem', color: '#718096' }}>Tipo Sistema</div>
                                <div style={{ fontWeight: 'bold' }}>{request.systemTypeLabel || 'N/D'}</div>
                            </div>
                            <div>
                                <div style={{ fontSize: '0.9rem', color: '#718096' }}>In Garanzia</div>
                                <div style={{ fontWeight: 'bold', color: request.warranty ? getIconColor('success') : getIconColor('error') }}>
                                    {request.warranty ? 'Sì' : 'No'}
                                </div>
                                {/* Con più servizi la garanzia è per servizio (richiesta #018) */}
                                {Array.isArray(request.systemTypes) && request.systemTypes.length > 1 && (
                                    <div style={{ fontSize: '0.8rem', marginTop: '4px' }}>
                                        {request.systemTypes.map(t => (
                                            <div key={t.typeId} style={{ color: t.warranty ? getIconColor('success') : '#718096' }}>
                                                {t.typeLabel}: {t.warranty ? 'in garanzia' : (t.expirationWarrantyDate ? 'fuori garanzia' : 'garanzia non indicata')}
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </div>
                            <div>
                                <div style={{ fontSize: '0.9rem', color: colors.inputText || '#718096' }}>In Manutenzione</div>
                                <div style={{ fontWeight: 'bold', color: (request.manteinanceContractTop || !!request.manteinanceContractId) ? getIconColor('success') : getIconColor('error') }}>
                                    {(request.manteinanceContractTop || !!request.manteinanceContractId) ? 'Sì' : 'No'}
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    {/* Card Assistenza */}
                    <div className="info-card" style={{
                        border: '1px solid #e2e8f0',
                        borderRadius: '12px',
                        padding: '16px',
                        boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
                        backgroundColor: 'white'
                    }}>
                        <h3 style={{ margin: '0 0 16px 0', display: 'flex', alignItems: 'center', gap: '8px' }}>
                            <i className="fa-solid fa-wrench" style={{ color: getIconColor('primary') }}></i>
                            Informazioni Assistenza
                        </h3>
                        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' }}>
                            <div>
                                <div style={{ fontSize: '0.9rem', color: '#718096' }}>Tipo Assistenza</div>
                                <div style={{ fontWeight: 'bold' }}>{request.assistanceTypeLabel || 'N/D'}</div>
                            </div>
                            <div>
                                <div style={{ fontSize: '0.9rem', color: '#718096' }}>Priorità</div>
                                <div style={{ fontWeight: 'bold' }}>{request.assistanceTypePriorityLabel || 'N/D'}</div>
                            </div>
                            <div>
                                <div style={{ fontSize: '0.9rem', color: '#718096' }}>Pagamento</div>
                                <div style={{ fontWeight: 'bold' }}>{request.paymentTypeLabel || 'N/D'}</div>
                            </div>
                            <div>
                                <div style={{ fontSize: '0.9rem', color: '#718096' }}>Stato</div>
                                <div style={{
                                    display: 'inline-block',
                                    fontWeight: 'bold',
                                    padding: '2px 8px',
                                    borderRadius: '4px',
                                    backgroundColor: '#edf2f7',
                                    color: '#4a5568'
                                }}>{request.statusLabel || 'N/D'}</div>
                            </div>
                        </div>
                    </div>
                    
                    {/* Card Tempistiche */}
                    <div className="info-card" style={{
                        border: '1px solid #e2e8f0',
                        borderRadius: '12px',
                        padding: '16px',
                        boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
                        backgroundColor: 'white'
                    }}>
                        <h3 style={{ margin: '0 0 16px 0', display: 'flex', alignItems: 'center', gap: '8px' }}>
                            <i className="fa-solid fa-calendar" style={{ color: getIconColor('primary') }}></i>
                            Tempistiche
                        </h3>
                        <div style={{ display: 'grid', gridTemplateColumns: '1fr', gap: '12px' }}>
                            <div>
                                <div style={{ fontSize: '0.9rem', color: '#718096' }}>Data Creazione</div>
                                <div style={{ fontWeight: 'bold' }}>
                                    {request.creationDate ? moment(request.creationDate).format('DD/MM/YYYY HH:mm') : 'N/D'}
                                </div>
                            </div>
                            <div>
                                <div style={{ fontSize: '0.9rem', color: '#718096' }}>Data Scadenza</div>
                                <div style={{
                                    fontWeight: 'bold', 
                                    color: request.expirationDate && moment(request.expirationDate).isBefore(moment(), 'day') ? getIconColor('error') : getIconColor('success')
                                }}>
                                    {request.expirationDate ? moment(request.expirationDate).format('DD/MM/YYYY HH:mm') : 'N/D'}
                                </div>
                            </div>
                            <div>
                                <div style={{ fontSize: '0.9rem', color: '#718096' }}>Data Accettazione</div>
                                <div style={{ fontWeight: 'bold' }}>
                                    {request.acceptedDate ? moment(request.acceptedDate).format('DD/MM/YYYY HH:mm') : 'N/D'}
                                </div>
                            </div>
                            {request.closedDate && (
                                <div>
                                    <div style={{ fontSize: '0.9rem', color: '#718096' }}>Data Chiusura</div>
                                    <div style={{ fontWeight: 'bold' }}>
                                        {moment(request.closedDate).format('DD/MM/YYYY HH:mm')}
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
                
                {/* Richieste e note */}
                <div className="card" style={{
                    border: '1px solid #e2e8f0',
                    borderRadius: '12px',
                    padding: '16px',
                    marginBottom: '24px',
                    boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
                    backgroundColor: 'white'
                }}>
                    <h3 style={{ margin: '0 0 16px 0', display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <i className="fa-solid fa-list-check" style={{ color: '#4299e1' }}></i>
                        Dettagli Richiesta
                    </h3>
                    
                    {request.useCases && request.useCases.length > 0 ? (
                        <div style={{ marginBottom: '16px' }}>
                            <div style={{ fontSize: '0.9rem', color: '#718096', marginBottom: '8px' }}>Casi d'uso</div>
                            <ul style={{ margin: '0', paddingLeft: '24px' }}>
                                {request.useCases.map((useCase, idx) => (
                                    <li key={idx} style={{ marginBottom: '8px' }}>
                                        {typeof useCase === 'object' ? (
                                            useCase.title ? 
                                            useCase.title : 
                                            useCase.useCase || useCase.useCaseLabel || JSON.stringify(useCase)
                                        ) : useCase}
                                    </li>
                                ))}
                            </ul>
                        </div>
                    ) : (
                        <div style={{ marginBottom: '16px' }}>
                            <div style={{ fontSize: '0.9rem', color: '#718096', marginBottom: '8px' }}>Casi d'uso</div>
                            <div style={{ fontStyle: 'italic', color: '#718096' }}>Nessun caso d'uso specificato</div>
                        </div>
                    )}
                    
                    {request.customerRequest && (
                        <div>
                            <div style={{ fontSize: '0.9rem', color: '#718096', marginBottom: '8px' }}>Note Cliente</div>
                            <div style={{ 
                                padding: '16px', 
                                backgroundColor: '#f7fafc', 
                                borderRadius: '8px', 
                                border: '1px solid #edf2f7',
                                lineHeight: '1.5'
                            }}>
                                {request.customerRequest}
                            </div>
                        </div>
                    )}
                </div>
                
                {/* Allegati se presenti */}
                {request.uploads && request.uploads.length > 0 && (
                    <div className="card" style={{
                        border: '1px solid #e2e8f0',
                        borderRadius: '12px',
                        padding: '24px',
                        boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
                        backgroundColor: 'white'
                    }}>
                        <h3 style={{ margin: '0 0 16px 0', display: 'flex', alignItems: 'center', gap: '8px' }}>
                            <i className="fa-solid fa-paperclip" style={{ color: '#4299e1' }}></i>
                            Allegati
                        </h3>
                        
                        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(220px, 1fr))', gap: '24px' }}>
                            {request.uploads.map((upload, idx) => {
                                // Determina l'icona del file in base al tipo MIME
                                let fileIcon = 'fa-file';
                                if (upload.contentType) {
                                    if (upload.contentType.startsWith('image/')) fileIcon = 'fa-file-image';
                                    else if (upload.contentType.includes('pdf')) fileIcon = 'fa-file-pdf';
                                    else if (upload.contentType.includes('word') || upload.contentType.includes('document')) fileIcon = 'fa-file-word';
                                    else if (upload.contentType.includes('excel') || upload.contentType.includes('sheet')) fileIcon = 'fa-file-excel';
                                }
                                
                                return (
                                    <div key={idx} style={{ 
                                        border: '1px solid #e2e8f0', 
                                        borderRadius: '8px', 
                                        padding: '24px',
                                        backgroundColor: '#f8fafc',
                                        display: 'flex',
                                        flexDirection: 'column',
                                        gap: '12px',
                                        cursor: 'pointer',
                                        transition: 'all 0.2s'
                                    }}
                                    onClick={() => window.open(`${import.meta.env.VITE_API_BASE_URL || ''}/uploads/${upload.filename}`, '_blank')}
                                    onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#edf2f7'}
                                    onMouseOut={(e) => e.currentTarget.style.backgroundColor = '#f8fafc'}
                                    >
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
                                            <div style={{
                                                width: '40px',
                                                height: '40px',
                                                borderRadius: '8px',
                                                backgroundColor: '#4299e1',
                                                color: 'white',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                fontSize: '18px'
                                            }}>
                                                <i className={`fa-solid ${fileIcon}`}></i>
                                            </div>
                                            <div style={{ flex: 1, overflow: 'hidden' }}>
                                                <div style={{ 
                                                    overflow: 'hidden', 
                                                    textOverflow: 'ellipsis', 
                                                    whiteSpace: 'nowrap',
                                                    fontWeight: 'bold'
                                                }}>
                                                    {upload.filename || `File ${idx+1}`}
                                                </div>
                                                <div style={{ fontSize: '0.8rem', color: '#718096' }}>
                                                    {upload.contentType || 'Tipo sconosciuto'}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                )}
            </div>
        );
    };

    // Funzione per aprire la modale di cambio stato
    const handleStatusChange = (request) => {
        console.log('handleStatusChange chiamata con:', request);
        console.log('accountData:', accountData);
        console.log('assistanceRequestStatus:', accountData?.settings?.assistanceRequestStatus);
        
        if (!request) {
            console.error('Request non definita!');
            return;
        }
        
        if (!accountData?.settings?.assistanceRequestStatus) {
            console.error('Settings degli stati assistenza non disponibili!');
            return;
        }
        
        console.log('statusId della richiesta:', request.statusId);
        
        setRequestToUpdateStatus(request);
        setStatusToUpdate(request.statusId || accountData.settings.assistanceRequestStatus[0]?._id);
        setShowStatusModal(true);
        console.log('Modale dovrebbe essere aperta ora, showStatusModal impostato a:', true);
    };
    
    // Funzione per chiudere la modale di cambio stato
    const handleCloseStatusModal = () => {
        setShowStatusModal(false);
        setRequestToUpdateStatus(null);
        setStatusToUpdate(null);
    };
    
    // Funzione per aggiornare lo stato dell'assistenza
    const handleUpdateStatus = async () => {
        if (!requestToUpdateStatus || !statusToUpdate) return;
        
        try {
            setIsUpdatingStatus(true);
            
            // Trova i dettagli del nuovo stato dalla lista degli stati disponibili
            const newStatus = accountData.settings.assistanceRequestStatus.find(s => s._id === statusToUpdate);
            if (!newStatus) {
                throw new Error('Stato selezionato non valido');
            }
            
            // Chiamata API per aggiornare lo stato: aggiorna anche la commessa collegata
            const token = localStorage.getItem('installamelo-auth-token');
            const response = await fetch(`${import.meta.env.VITE_API_BASE_URL || ''}/assistanceRequests/updateStatus`, {
                method: 'PATCH',
                headers: {
                    'Content-Type': 'application/json',
                    'auth-token': token
                },
                body: JSON.stringify({
                    assistanceRequestId: requestToUpdateStatus._id,
                    accountId: user.accountId,
                    statusCode: newStatus.code,
                    userId: user.userId,
                    userLabel: `${user.name || ''} ${user.surname || ''}`.trim(),
                })
            });
            
            if (!response.ok) {
                throw new Error(`Errore nella risposta: ${response.status}`);
            }
            
            const result = await response.json();
            
            // Aggiorna la lista delle richieste con lo stato aggiornato
            const updatedRequests = assistanceRequests.map(req => 
                req._id === requestToUpdateStatus._id ? {...req, statusId: newStatus._id, statusLabel: newStatus.name || newStatus.label} : req
            );
            setAssistanceRequests(updatedRequests);
            setFilteredRequests(updatedRequests);
            
            // Chiudi la modale e mostra un messaggio di successo
            handleCloseStatusModal();
            toast.success(`Stato aggiornato a: ${newStatus.name || newStatus.label}`);
            // Esito sulla commessa collegata
            (result.jobs || []).forEach(job => {
                if (job.updated) toast.success(`Commessa ${job.code}: ${job.statusLabel}`);
                else if (job.reason !== 'già in questo stato') toast.info(`Commessa ${job.code} non cambiata (${job.reason})`);
            });
        } catch (error) {
            console.error('Errore durante l\'aggiornamento dello stato:', error);
            toast.error(`Errore durante l'aggiornamento: ${error.message}`);
        } finally {
            setIsUpdatingStatus(false);
        }
    };

    return (
        <div className='page'>
            <h1>Richieste di Assistenza</h1>
            
            {/* Modale per visualizzare i dettagli della richiesta */}
            {rightModalIsOpen && rightModalMode === 'viewAssistanceRequest' && (
                <RightModal>
                    {selectedRequest && (
                        <div>
                            <h2>Dettagli Richiesta</h2>
                            <AssistanceRequestDetails request={selectedRequest} />
                            <div style={{ marginTop: '20px', display: 'flex', justifyContent: 'space-between' }}>
                                <button 
                                    className="primary" 
                                    onClick={() => handleEditRequest(selectedRequest)}
                                >
                                    Modifica Richiesta
                                </button>
                            </div>
                        </div>
                    )}
                </RightModal>
            )}
            

            
            {/* Barra dei filtri */}
            <div className="filtri-container bg-gray-100 p-4 mb-5 rounded-lg">
                <div className="flex flex-wrap justify-between items-end gap-4">
                    <div className="flex flex-wrap items-end gap-4">
                        <div>
                            <label htmlFor="mese-select" className="block mb-2 font-medium text-sm text-gray-700">Mese:</label>
                            <div className="w-48">
                                <MySelect 
                                    id="mese-select"
                                    placeholder="Seleziona mese" 
                                    isClearable={true}
                                    value={meseSelezionato ? {
                                        id: meseSelezionato,
                                        text: mesi.find(m => m.value === meseSelezionato)?.label || ''
                                    } : null}
                                    options={[{id: '', text: 'Tutti i mesi'}, ...mesi.map(mese => ({
                                        id: mese.value,
                                        text: mese.label
                                    }))]} 
                                    onChange={(selected) => {
                                        if (selected) {
                                            handleMeseChange({ target: { value: selected.id } });
                                        } else {
                                            handleMeseChange({ target: { value: '' } });
                                        }
                                    }}
                                />
                            </div>
                        </div>
                        
                        <div>
                            <label htmlFor="anno-select" className="block mb-2 font-medium text-sm text-gray-700">Anno:</label>
                            <div className="w-40">
                                <MySelect 
                                    id="anno-select"
                                    placeholder="Seleziona anno" 
                                    value={annoSelezionato ? {
                                        id: annoSelezionato,
                                        text: anni.find(a => a.value === annoSelezionato)?.label || ''
                                    } : null}
                                    options={anni.map(anno => ({
                                        id: anno.value,
                                        text: anno.label
                                    }))}
                                    onChange={(selected) => {
                                        if (selected) {
                                            handleAnnoChange({ target: { value: selected.id } });
                                        }
                                    }}
                                />
                            </div>
                        </div>
                        
                        <div>
                            <label htmlFor="stato-select" className="block mb-2 font-medium text-sm text-gray-700">Stato:</label>
                            <div className="w-52">
                                <MySelect 
                                    id="stato-select"
                                    placeholder="Seleziona stato" 
                                    isClearable={true}
                                    value={statoSelezionato ? {
                                        id: statoSelezionato,
                                        text: statiRichiesta.find(s => s._id === statoSelezionato)?.name || 'Stato non trovato'
                                    } : null}
                                    options={statiRichiesta.map((stato) => ({
                                        id: stato._id,
                                        text: stato.name || stato.label || 'N/D'
                                    }))}
                                    onChange={(selected) => {
                                        if (selected) {
                                            handleStatoChange({ target: { value: selected.id } });
                                        } else {
                                            handleStatoChange({ target: { value: '' } });
                                        }
                                    }}
                                />
                            </div>
                        </div>

                        <div className="w-64">
                            <label className="block mb-2 font-medium text-sm text-gray-700">Cliente:</label>
                            <div className="min-w-full">
                                <CustomerSelect 
                                    selectedOption={selectedCustomer}
                                    setSelectedOption={handleCustomerChange}
                                    placeholder="Digita per cercare il cliente"
                                    showSelectedLabel={false}
                                />
                            </div>
                        </div>
                    </div>
                    
                    <div>
                        <button 
                            onClick={() => {
                                saveFiltersToSessionStorage();
                                navigate('/assistanceRequestsNoAI/new');
                            }}
                            className="primary flex items-center gap-2"
                        >
                            <i className="fa-solid fa-plus"></i>
                            <span>+ Nuova Assistenza</span>
                        </button>
                    </div>
                </div>
            </div>
            
            {/* Visualizzazione delle richieste filtrate come card */}
            <div className="richieste-container">
                {filteredRequests.length === 0 ? (
                    <p>Nessuna richiesta di assistenza trovata.</p>
                ) : (
                    <>
                        <p>Numero di richieste trovate: {filteredRequests.length}</p>
                        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(350px, 1fr))', gap: '20px', marginTop: '20px' }}>
                            {filteredRequests.map((request, index) => {
                                // Arricchisce l'oggetto request con il colore del tipo di assistenza
                                const assistanceTypeColor = getAssistanceTypeColor(request);
                                const requestWithColor = {
                                    ...request,
                                    assistanceTypeColor // Aggiungiamo il colore direttamente all'oggetto request
                                };
                                
                                return (
                                    <AssistanceRequestCard 
                                        key={index}
                                        request={requestWithColor}
                                        getCardBackgroundColor={getCardBackgroundColor}
                                        getStatusColor={getStatusColor}
                                        onClick={handleRequestClick}
                                        onStatusChange={handleStatusChange}
                                        onEditRequest={handleEditRequest}
                                        onDeleteRequest={handleDeleteRequest}
                                        onOpenScheduling={(preselectedJob) => {
                                            setSchedulingPreselectedJob(preselectedJob);
                                            setShowSchedulingOffcanvas(true);
                                        }}
                                    />
                                );
                            })}
                        </div>
                    </>
                )}
            </div>
            
            {/* Modale per il cambio di stato */}
            {showStatusModal && (
                <div 
                    style={{
                        display: 'block', 
                        backgroundColor: 'rgba(0,0,0,0.5)',
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        width: '100vw',
                        height: '100vh',
                        zIndex: 9999,
                        overflow: 'auto',
                        paddingLeft: 0,
                        paddingRight: 0
                    }} 
                    tabIndex="-1"
                >
                    <div style={{
                        position: 'relative',
                        width: '500px',
                        maxWidth: '90%',
                        margin: '10vh auto',
                        backgroundColor: '#fff',
                        borderRadius: '5px',
                        boxShadow: '0 3px 9px rgba(0,0,0,.5)',
                        animation: 'fadeIn 0.3s'
                    }}>
                        <div style={{ backgroundColor: '#fff', border: 'none', borderRadius: '5px', overflow: 'hidden' }}>
                            <div style={{ padding: '15px', borderBottom: '1px solid #e5e5e5', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                <h5 style={{ margin: 0, fontWeight: 'bold' }}>Cambia Stato Assistenza</h5>
                                <button 
                                    type="button" 
                                    onClick={handleCloseStatusModal}
                                    style={{
                                        border: 'none',
                                        background: 'transparent',
                                        fontSize: '20px',
                                        cursor: 'pointer'
                                    }}
                                >
                                    &times;
                                </button>
                            </div>
                            <div style={{ padding: '15px' }}>
                                {requestToUpdateStatus && (
                                    <div>
                                        <p><strong>Cliente:</strong> {requestToUpdateStatus.customerLabel || 'N/D'}</p>
                                        <p><strong>Codice:</strong> {requestToUpdateStatus.code || 'N/D'}</p>
                                        <p><strong>Tipo:</strong> {requestToUpdateStatus.assistanceTypeLabel || 'N/D'}</p>
                                        
                                        <div style={{ marginTop: '20px', marginBottom: '15px' }}>
                                            <label htmlFor="status-select" style={{ display: 'block', marginBottom: '8px', fontWeight: 500 }}>Seleziona nuovo stato:</label>
                                            <select
                                                id="status-select"
                                                value={statusToUpdate}
                                                onChange={(e) => setStatusToUpdate(e.target.value)}
                                                disabled={isUpdatingStatus}
                                                style={{
                                                    width: '100%',
                                                    padding: '8px 12px',
                                                    border: '1px solid #ced4da',
                                                    borderRadius: '4px',
                                                    appearance: 'auto'
                                                }}
                                            >
                                                {accountData?.settings?.assistanceRequestStatus?.map((status) => (
                                                    <option key={status._id} value={status._id}>
                                                        {status.name}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>
                                )}
                            </div>
                            <div style={{ padding: '15px', borderTop: '1px solid #e5e5e5', display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
                                <button 
                                    type="button" 
                                    onClick={handleCloseStatusModal}
                                    disabled={isUpdatingStatus}
                                    style={{
                                        padding: '8px 16px',
                                        backgroundColor: '#6c757d',
                                        color: 'white',
                                        border: 'none',
                                        borderRadius: '4px',
                                        cursor: isUpdatingStatus ? 'not-allowed' : 'pointer',
                                        opacity: isUpdatingStatus ? 0.65 : 1
                                    }}
                                >
                                    Annulla
                                </button>
                                <button 
                                    type="button" 
                                    onClick={handleUpdateStatus}
                                    disabled={isUpdatingStatus}
                                    style={{
                                        padding: '8px 16px',
                                        backgroundColor: '#0d6efd',
                                        color: 'white',
                                        border: 'none',
                                        borderRadius: '4px',
                                        cursor: isUpdatingStatus ? 'not-allowed' : 'pointer',
                                        opacity: isUpdatingStatus ? 0.65 : 1
                                    }}
                                >
                                    {isUpdatingStatus ? (
                                        <>
                                            <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                            Aggiornamento...
                                        </>
                                    ) : (
                                        'Cambia Stato'
                                    )}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
            
            {/* Modale di conferma eliminazione */}
            {showDeleteModal && requestToDelete && (
                <div 
                    style={{
                        display: 'block', 
                        backgroundColor: 'rgba(0,0,0,0.5)',
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        width: '100vw',
                        height: '100vh',
                        zIndex: 9999,
                        overflow: 'auto',
                        paddingLeft: 0,
                        paddingRight: 0
                    }} 
                    tabIndex="-1"
                >
                    <div style={{
                        position: 'relative',
                        width: '500px',
                        maxWidth: '90%',
                        margin: '10vh auto',
                        backgroundColor: '#fff',
                        borderRadius: '5px',
                        boxShadow: '0 3px 9px rgba(0,0,0,.5)',
                        animation: 'fadeIn 0.3s'
                    }}>
                        <div style={{ backgroundColor: '#fff', border: 'none', borderRadius: '5px', overflow: 'hidden' }}>
                            <div style={{ padding: '15px', borderBottom: '1px solid #e5e5e5', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                <h5 style={{ margin: 0, fontWeight: 'bold', color: '#dc3545' }}>
                                    <i className="fa-solid fa-exclamation-triangle me-2"></i>
                                    Conferma eliminazione
                                </h5>
                                <button 
                                    type="button" 
                                    onClick={handleCloseDeleteModal} 
                                    style={{ background: 'none', border: 'none', fontSize: '1.5rem', fontWeight: 'bold', opacity: 0.5, cursor: 'pointer' }}
                                >
                                    &times;
                                </button>
                            </div>
                            <div style={{ padding: '20px' }}>
                                <p>Sei sicuro di voler eliminare questa richiesta di assistenza?</p>
                                <div style={{ marginTop: '10px', backgroundColor: 'rgba(0,0,0,0.03)', padding: '10px', borderRadius: '4px' }}>
                                    <p style={{ margin: 0, fontWeight: 'bold' }}>
                                        {requestToDelete.code} - {requestToDelete.customerLabel || 'Cliente N/D'}
                                    </p>
                                    <p style={{ margin: '5px 0 0 0', fontSize: '0.9rem' }}>
                                        {requestToDelete.systemTypeLabel || 'Tipo sistema N/D'}
                                        {requestToDelete.systemLabel && ` - ${requestToDelete.systemLabel}`}
                                    </p>
                                </div>
                                
                                {/* Avviso commessa collegata */}
                                {isCheckingLinkedJob && (
                                    <div style={{ marginTop: '15px', padding: '10px', backgroundColor: '#f8f9fa', borderRadius: '4px', textAlign: 'center' }}>
                                        <i className="fa-solid fa-spinner fa-spin me-2"></i>
                                        Verifica commessa collegata...
                                    </div>
                                )}
                                
                                {!isCheckingLinkedJob && linkedJobInfo && (
                                    <div style={{ 
                                        marginTop: '15px', 
                                        padding: '12px', 
                                        backgroundColor: '#fff3cd', 
                                        border: '1px solid #ffecb5',
                                        borderRadius: '4px',
                                        color: '#856404'
                                    }}>
                                        <p style={{ margin: 0, fontWeight: 'bold' }}>
                                            <i className="fa-solid fa-link me-2"></i>
                                            Commessa collegata trovata!
                                        </p>
                                        <p style={{ margin: '8px 0 0 0', fontSize: '0.95rem' }}>
                                            Questa assistenza ha una commessa collegata: <strong>{linkedJobInfo.jobCode}</strong>
                                        </p>
                                        <p style={{ margin: '8px 0 0 0', fontSize: '0.9rem', color: '#dc3545', fontWeight: 'bold' }}>
                                            <i className="fa-solid fa-exclamation-triangle me-1"></i>
                                            Eliminando questa assistenza verrà eliminata anche la commessa collegata!
                                        </p>
                                    </div>
                                )}
                                
                                <p style={{ marginTop: '15px', color: '#dc3545' }}>
                                    <strong>Attenzione:</strong> Questa operazione non può essere annullata.
                                </p>
                            </div>
                            <div style={{ padding: '15px', borderTop: '1px solid #e5e5e5', display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
                                <button 
                                    type="button" 
                                    onClick={handleCloseDeleteModal}
                                    disabled={isDeleting}
                                    style={{
                                        padding: '8px 16px',
                                        backgroundColor: '#6c757d',
                                        color: 'white',
                                        border: 'none',
                                        borderRadius: '4px',
                                        cursor: isDeleting ? 'not-allowed' : 'pointer',
                                        opacity: isDeleting ? 0.65 : 1
                                    }}
                                >
                                    Annulla
                                </button>
                                <button 
                                    type="button" 
                                    onClick={handleConfirmDelete}
                                    disabled={isDeleting}
                                    style={{
                                        padding: '8px 16px',
                                        backgroundColor: '#dc3545',
                                        color: 'white',
                                        border: 'none',
                                        borderRadius: '4px',
                                        cursor: isDeleting ? 'not-allowed' : 'pointer',
                                        opacity: isDeleting ? 0.65 : 1
                                    }}
                                >
                                    {isDeleting ? (
                                        <>
                                            <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                            Eliminazione...
                                        </>
                                    ) : (
                                        'Elimina richiesta'
                                    )}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
            
            {/* SchedulingOffcanvas a livello di pagina */}
            <SchedulingOffcanvas
                isOpen={showSchedulingOffcanvas}
                onClose={() => {
                    setShowSchedulingOffcanvas(false);
                    setSchedulingPreselectedJob(null);
                }}
                selectedDate={new Date()}
                preselectedJob={schedulingPreselectedJob}
                initialTab="job"
                onSuccess={() => {
                    setShowSchedulingOffcanvas(false);
                    setSchedulingPreselectedJob(null);
                    toast.success('Appuntamento pianificato con successo!');
                    // Ricarica i dati per mostrare lo stato aggiornato
                    fetchAssistanceRequests();
                }}
            />
    </div>
    )
}

export default AssistanceRequests
